import { createFileRoute } from "@tanstack/react-router";

import FeatureTogglesAdmin from "@/components/FeatureTogglesAdmin";

// Passthrough, same shape as every other admin route (see voice.tsx): the console component
// owns everything, admin/route.tsx owns the shell and the gate.
export const Route = createFileRoute("/admin/feature-toggles")({
  component: FeatureTogglesAdmin,
});
